import { QuoteLocationSurchargeBase } from "./quote-location-surcharge-base.model";
import { ContainerPrices } from "../../../shared/container/container-prices.model";
import { Quote } from "../../quote.type";

export class FclQuoteLocationSurcharge extends QuoteLocationSurchargeBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    public name: string,
    public internalNote: string,
    private containers: ContainerPrices,
    private shipmentPrice: number,
    public quote: Quote,
    public shipmentDisplayUnitName: string,
  ) {
    super(id, discriminator, name, internalNote, quote);
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }

  public getShipmentPrice(): number {
    return this.shipmentPrice;
  }

  public setShipmentPrice(param: number) {
    this.shipmentPrice = param;
  }

  public hasAllValues(eq: string[]): boolean {
    return this.getContainers().hasAllPrices(eq);
  }
}
